'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _includes = require('lodash/includes');

var _includes2 = _interopRequireDefault(_includes);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Utilities for working with objects.
 * @module ObjectUtils
 */
var ObjectUtils = {
    /**
     * Creates a query string representation of an object.
     * @static
     * @function querify
     * @param {Object} ob - The object to querify.
     * @example
     * ObjectUtils.querify({foo: 'hello', baz: 'there'});
     * @returns {String} - The query string output.
     */
    querify: function querify(ob) {
        return (0, _map2.default)(ob, function (value, key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(value);
        }).join('&');
    },


    /**
     * Returns the properties of an object whose keys partially match the provided string.
     * @static
     * @function getPartialMatchedProps
     * @param {Object} ob - The object to get properties from.
     * @param {String} match - The string to match keys against.
     * @example
     * ObjectUtils.getPartialMatchedProps({foo: 'foo', baz: 'baz', fool: 'fool'}, 'foo');
     * @returns {Object} - The object containing only the properties whose keys partially matched.
     */
    getPartialMatchedProps: function getPartialMatchedProps(ob, match) {
        var matched = {};

        (0, _forEach2.default)(ob, function (value, key) {
            if ((0, _includes2.default)(key, match)) {
                matched[key] = value;
            }
        });

        return matched;
    }
};

exports.default = ObjectUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spothero/utils/lib/object/object.js
// module id = 289
// module chunks = 0